import React from 'react';
import PropTypes from 'prop-types';
import { getIn } from 'formik';
import withLabel from '../Label';
import './styles.scss';

export const Selection = ({
  formik: { values, handleChange },
  disabled,
  id,
  label,
  name,
  options,
  placeholder,
  required,
  isEmpty,
  emptyLabel,
  ...rest
}) => (
  <select
    {...rest}
    id={id || name}
    name={name}
    value={getIn(values, name)}
    disabled={disabled}
    onChange={handleChange}
  >
    {placeholder && <option value="">{`${placeholder}${!label && required ? ' *' : ''}`}</option>}
    {isEmpty ? (
      <option disabled value="">
        {emptyLabel}
      </option>
    ) : (
      undefined
    )}
    {options.map(option => (
      <option key={option.text || option.label} value={option.value}>
        {option.text || option.label}
      </option>
    ))}
  </select>
);

Selection.propTypes = {
  /** @ignore */
  formik: PropTypes.instanceOf(Object).isRequired,
  /** Adds a custom class to the Selection wrapper div */
  className: PropTypes.string,
  /** Adds a custom inline styles to the Selection wrapper div */
  style: PropTypes.instanceOf(Object),
  /** Disables the Selection Field */
  disabled: PropTypes.bool,
  /** Sets an Id for the Selection Field, if not passed, the id will be the name */
  id: PropTypes.string,
  /** Sets the main Label for the Selection Field */
  label: PropTypes.string,
  /** Sets the Name of the Selection Field */
  name: PropTypes.string.isRequired,
  /** Sets a Placeholder as the first option with no value */
  placeholder: PropTypes.string,
  /** Array in the shape of [ { value: string or number, label: string } ] */
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
    })
  ).isRequired,
  /** Sets a hint text after/below the Selection component */
  hint: PropTypes.string,
  /** Sets the field as requierd, if label is passed, an * is added to the end of the main label. Validation will only work if you pass the required() method in the yup validation schema */
  required: PropTypes.bool,
  isEmpty: PropTypes.bool,
  emptyLabel: PropTypes.bool
};

Selection.defaultProps = {
  className: null,
  style: null,
  disabled: false,
  id: null,
  label: null,
  placeholder: null,
  hint: null,
  required: false,
  isEmpty: false,
  emptyLabel: false
};

export default withLabel('selection')(Selection);
